import React from 'react'
import BoxContainer from './BoxContainer'
import Text from 'core-system/Text'
import palette from 'core-system/Themes/palette'
import launchProgramsWordings from '../../Shared/wordings.json'
import { ReactComponent as CalendarIcon } from './calendar-icon.svg'
import { ReactComponent as UsersIcon } from './users-icon.svg'
import { ReactComponent as TrendingUpIcon } from './trending-up-icon.svg'
import styled, { css } from 'styled-components'
import { Link } from 'react-router-dom'
import { Locations } from 'shared/Router/Locations'

const IconLineContainer = styled.div`
  display: flex;
  align-items: center;
  gap: 0.75rem;
  margin-bottom: 1.125rem;
`

const commonIconStyles = css`
  width: 1.25rem;
  height: 1.25rem;
  color: ${(props) => props.theme.palette.grey.grey600};
`

const LaunchDateContainer = styled.div`
  display: flex;
  align-items: center;
  gap: 0.25rem;
`

const CalendarIconStyled = styled(CalendarIcon)`
  ${commonIconStyles}
`

const UsersIconStyled = styled(UsersIcon)`
  ${commonIconStyles}
`

const TrendingUpIconStyled = styled(TrendingUpIcon)`
  ${commonIconStyles}
`

const LinkStyled = styled(Link)`
  color: ${(props) => props.theme.palette.accent.blue500};
  text-decoration: none;
  font-weight: 600;
`

const IconLine = ({
  icon,
  text,
}: {
  icon: React.ReactNode
  text: string | React.ReactNode
}) => {
  return (
    <IconLineContainer>
      {icon}
      <Text variant='action4' color={palette.text.secondary}>
        {text}
      </Text>
    </IconLineContainer>
  )
}

const ProgramDetails = ({ launchDate }: { launchDate: string }) => {
  return (
    <BoxContainer>
      <Text variant='h5' marginBottom='1.5rem'>
        {launchProgramsWordings.programDetails.title}
      </Text>
      <IconLine
        icon={<CalendarIconStyled />}
        text={
          <LaunchDateContainer>
            <Text variant='action4' color={palette.text.secondary}>
              Launch Date:
            </Text>
            <Text variant='action4' color={palette.text.secondary}>
              <b>{launchDate}</b>
            </Text>
          </LaunchDateContainer>
        }
      />
      <IconLine
        icon={<UsersIconStyled />}
        text={launchProgramsWordings.programDetails.notification}
      />
      <IconLine
        icon={<TrendingUpIconStyled />}
        text={launchProgramsWordings.programDetails.dashboard}
      />
      <Text variant='action4' color={palette.text.secondary}>
        {launchProgramsWordings.programDetails.caption}{' '}
        <LinkStyled to={Locations.Programs.Overview}>Programs</LinkStyled> page
      </Text>
    </BoxContainer>
  )
}

export default ProgramDetails
